import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Dropdown Design Guidelines",
  "title": "Dropdown",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="dropdown" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Dropdowns (also referred to as Dropdown Menus) display a list of options that
  a user can select from within a contextual overlay.
      </LeadParagraph>
      <h2>{`Usage`}</h2>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "54.05405405405405%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAxUlEQVQoz52RuwrCQBBF/V0rwS6IiOB3WGgRUPALBMFCCbYqms7Cxspddu4+xk2EBCWaQKKHWw2ceTAtXYKgFSEPEZQCoCtplUveuzR9FOKds5X+hwxoZrONrtPwNFvE4fw8W8TjyXF/uHlvqdTgS4b3Npyfu8GmP9oFg6g3jNqd9XJ1SVMmQv3azJYdnCVmzYwkYWtt5d0VMoB7hpRSCAHAmH9lIjLGNJW11kKIXJZSZpMby0SklKIXyGj65+L+b36Wa3kCPAVw9202ZpUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/version/4.9.1/static/7a7ae59931188091d7bc7c6514e78be5/e3189/dropdown-intro-example.png",
            "srcSet": ["/version/4.9.1/static/7a7ae59931188091d7bc7c6514e78be5/a2ead/dropdown-intro-example.png 259w", "/version/4.9.1/static/7a7ae59931188091d7bc7c6514e78be5/6b9fd/dropdown-intro-example.png 518w", "/version/4.9.1/static/7a7ae59931188091d7bc7c6514e78be5/e3189/dropdown-intro-example.png 1035w", "/version/4.9.1/static/7a7ae59931188091d7bc7c6514e78be5/aa440/dropdown-intro-example.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </figure>
      <hr></hr>
      <h2>{`Anatomy`}</h2>
      <h3>{`Text List`}</h3>
      <p>{`Dropdown menus typically contain a list of text-only menu items.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "93.43629343629343%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7UlEQVQ4y42Uu47UMBSG91npeAWeYhsaCiQ6SkQDQqKgQ2IlBA0CCRakTHYmk9iOzzW+okxm2Nsw8OvIxYk/5/fROT6T02KWGLXWox/PTpHEUhJcfDXnL0R1fxbv1iPwsuFPEEkt7vWHzYNznqaZCJNMKikuZ92CeQR2PgAHTwF48qgjKKACqUd2Hi9banv8/EM8iOoBBhRiBAg6eTuOzlljhLiWWnOuudRSYwxgnSDx4Bbne1hz0ZKRMYQAAM45Y0wIod5QjBGJZsPL/WeYWXO0T175tx+RMNCcnaYphICIInIL3mVuVJtZau4fPXPP3yGhetxut13XGWPatrXWnoT3tvNsmzDGWEpJKcUY806qOk3TkjwOC5IwI6Kqrtfr1WrVdV3TNJvNpt0pxvh3WOYqIM5/rrWWUuo9XdvmO3AMmgIKi2qzWjVNcwROh2qHm9WuefvwsXv6BozVzhbPsffFcx4pOUzGp8Fnh9Mw+p8tby1++XVoEmZJwb18DxffwIMi2X5A58GNglRiyiHmEEtMQRR3Sd66ue0Ptnmudk6AEGNcX12ZwQx9Lyx37wygcn8wlvYcPfRWRxDjxXmyIxqHvZ3DOBisv1zxVQ+fvt/u7cNUEREgIuGyItF1MO3Hjfj4POtJif7/Y/Av/QZ4M0IC4FhBjwAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/d36d6b7dd8bb32b0eac7e2eb96b8b2c2/8ae3e/anatomy-text-list.png",
                  "srcSet": ["/version/4.9.1/static/d36d6b7dd8bb32b0eac7e2eb96b8b2c2/a2ead/anatomy-text-list.png 259w", "/version/4.9.1/static/d36d6b7dd8bb32b0eac7e2eb96b8b2c2/6b9fd/anatomy-text-list.png 518w", "/version/4.9.1/static/d36d6b7dd8bb32b0eac7e2eb96b8b2c2/8ae3e/anatomy-text-list.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption">{`
            There is 8px of space above the first item in the dropdown, and
            below the last item. There is also 4px of space above and below the
            divider.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<ol parentName="div">{`
        `}<li parentName="ol">{`Container`}</li>{`
        `}<li parentName="ol">{`Text Label`}</li>{`
        `}<li parentName="ol">{`Divider`}</li>{`
      `}</ol>{`
    `}</div>{`
  `}</div>
      </div>
      <h3>{`Text and Icon List`}</h3>
      <p>{`Dropdown menu items may also use an icon on the left side to help clarify the meaning of the menu choice.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "93.43629343629343%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAABoElEQVQ4y6WTvW4UMRSF83i8BCXPQUdHA6KnThklFR0FQigdSpFiASkr5Wd31h5f33Ovf8ZGntndJEqGVcQp3Hi+Oefax0dyUIAwnt05OkhqSqHWl8OADIl+/jKfv4jqPOwZzo+AAJgWkJda+rMft6/fS5iDAR2ylkFUIBJTCqNSSjFGVVWIxgDmJzBD62BPvm8+nEAVxnkiDUFVjTHe+1prLaXWOoaBeG7jPICLPf7avTsGAytjjRGRoLper/u+rzs1VEVrkRAEj2IPoRSoiGrOOcaYUhKRMnpuYRH0RN8usDaN38Ix8NUtX14htDN1zhljnHOLxcL2fUUo1teesenp4vf1q7d0ftn8GVPsuvl0evfmIzxzZ8cZy95zyHnIuQwDM7fkd92+Mzvnm47/XDdnVWtt13VEtFwurbU55/uZgSnww6tqvOSE8ZftaoCcs3OOmfcRtjCeloRbgQGEEIwxRBRjdM5576f57+G5ejJzCMFaS0QAVquVtXZaD8MiQkS7Xm+/07HVzLzfmoUB+Oc0HfXhV6Uzevl7/qf+C/4LEzJCm4P2+hsAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/de8e4f8ac5219b66fdd6c370768a12d9/8ae3e/anatomy-icon-and-text.png",
                  "srcSet": ["/version/4.9.1/static/de8e4f8ac5219b66fdd6c370768a12d9/a2ead/anatomy-icon-and-text.png 259w", "/version/4.9.1/static/de8e4f8ac5219b66fdd6c370768a12d9/6b9fd/anatomy-icon-and-text.png 518w", "/version/4.9.1/static/de8e4f8ac5219b66fdd6c370768a12d9/8ae3e/anatomy-icon-and-text.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<ol parentName="div">{`
        `}<li parentName="ol">{`Container`}</li>{`
        `}<li parentName="ol">{`Icon`}</li>{`
        `}<li parentName="ol">{`Text label`}</li>{`
        `}<li parentName="ol">{`Divider`}</li>{`
      `}</ol>{`
    `}</div>{`
  `}</div>
      </div>
      <h3>{`Selection State List`}</h3>
      <p>{`Dropdown menus may use a selection state by placing a checkmark next to the currently active choice.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "93.43629343629343%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA80lEQVQ4y92TbYuEIBCA9///xaAIzPCl1HxJc5wOkj3ittsO7ts+HwZRHmcGx8f6Dx4fIIcX6ub59EKOMTrntm3b9x0RtycpJQBIKcUYSyk5Z+dcjPGnbK3NOe8HnHNCCKWUc661ppS2bRtCKKVYa2/kUgoi7i/knH+VAcAYAwDjODZNQwiRUjLG+r7vus4Y86fMZ2oJNb7LfO55GAal1DRNQggp5TAMhBAAuJcRsRzAASLmg3sZEed5FkJYaxljUkqttZTSe/9O/n7ndV2NMSEEpZQxxnu/LEsI4brnOkDLE+ec977GuqjUK+5nO1zxGV/yC69PSha56GquAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/c9b26cee481349a364b9c947912d0525/8ae3e/anatomy-selection-state-list.png",
                  "srcSet": ["/version/4.9.1/static/c9b26cee481349a364b9c947912d0525/a2ead/anatomy-selection-state-list.png 259w", "/version/4.9.1/static/c9b26cee481349a364b9c947912d0525/6b9fd/anatomy-selection-state-list.png 518w", "/version/4.9.1/static/c9b26cee481349a364b9c947912d0525/8ae3e/anatomy-selection-state-list.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<ol parentName="div">{`
        `}<li parentName="ol">{`Container`}</li>{`
        `}<li parentName="ol">{`Selected item indicator`}</li>{`
        `}<li parentName="ol">{`Text label`}</li>{`
      `}</ol>{`
    `}</div>{`
  `}</div>
      </div>
      <h3>{`Grouping`}</h3>
      <p>{`Some dropdowns benefit from organizing the choices or options into groups, and then labelling those groups.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "123.16602316602317%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAZCAIAAAC+dZmEAAAACXBIWXMAAAsTAAALEwEAmpwYAAABTklEQVQ4y6WU627DIAyF+/5P2UlpGqAmXGxuoTAp1qpq1dqgnR8WivzJMTbnFP+h0+un8KJDMKfWWrdt41hK2bYt7+KEP2EiyjkrpYQQUkoAWNcVAFprvfdSCiJ+gBGRiJxzRJRS8t4PwMuyCCG899fr1RiTc+67DsGllJwzt1pr5bJHYW4YEaWUxhgiGoCJCBG52xhjrXUAds557/kQQiilDMC3200p5b1XSllrQwi999YaD+IdHGPkVL6n+/3eWuOYUvpced41TZMQQmu9LMvAnHkHeR/LroGe53m+XC7GmGmaAAARB+D+pEfzR+GvXQBwPp+llNbao3BKiQs+l+X4eVQppXVd9S5jjHPOWssbnlLiWb777XUXAFhrEVFrPTAq9oAYo9baez9228YYACAiAOC3cQiOMbKBhBAeERHdj9552C/3ZH7Meo/79jfzVqTPMzdiKwAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/10052b0950218e00ef38606c78481332/8ae3e/dropdown-groups.png",
                  "srcSet": ["/version/4.9.1/static/10052b0950218e00ef38606c78481332/a2ead/dropdown-groups.png 259w", "/version/4.9.1/static/10052b0950218e00ef38606c78481332/6b9fd/dropdown-groups.png 518w", "/version/4.9.1/static/10052b0950218e00ef38606c78481332/8ae3e/dropdown-groups.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <h3>{`Width`}</h3>
      <p>{`A dropdown will stretch horizontally by default to fit the longest item in the list. If you know the content of that dropdown is going to cause it to stretch beyond the boundaries of the browser window, you may set a width on that dropdown.`}</p>
      <p><strong parentName="p">{`Note:`}</strong>{` For Responsive applications, dropdowns should have a width no greater than 320px.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "86.10038610038609%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAIAAABSJhvpAAAACXBIWXMAAAsTAAALEwEAmpwYAAABmklEQVQ4y6WQy07CQBSG50U0GBUoUiiXgCTGuGLnxjfQxIWCIkQkEaxRF+5MfAIXoO/kNSGltIWEYIe2FOZiaJVgobjwy5eTcxZ//swAJsw79LEVf6jChEf6Q2UfW/azZft0CJhw3iGXKAWjpUD4go1dcsmrWOomkrxmY3ww+i0bu7RP4FndnXRpdW8rXeESRSZUYTh+M30X37jdTN8FIrw3WPZ4zxaWTxmOX1k7X1wpAh+bn9YfKq1F+P2Dh6PC02Gumj2pHeWfsvnHTK6ayVWPC4/Zk1omVwXR9WuH8dRNMMpv79wbhkkpIYSOJh5QguhvwMurOO3zi/j+0dQ0XRSbitKWZaXZlBSlRQhFmGBM8WgSgJA5035fRwhhjBFCxMLeEUKDwQAhNBwOAYS9maoq1HVdkiRZliVJqtfrjUaj3W53Oh1BEN4sgOYChNButmsdr8UW88KmaYoWGGP683WTi2tYVdVxZrr5jzCE0DAMQRBarRZ1YV5z38IwjKELruFer9ftdj8tui64hjVN0y3GyzTzwn/yr/AXK4sjt41EJW8AAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/4f36b2f8c9c0007826eeb7cae14fb20b/8ae3e/menu-too-wide.png",
                  "srcSet": ["/version/4.9.1/static/4f36b2f8c9c0007826eeb7cae14fb20b/a2ead/menu-too-wide.png 259w", "/version/4.9.1/static/4f36b2f8c9c0007826eeb7cae14fb20b/6b9fd/menu-too-wide.png 518w", "/version/4.9.1/static/4f36b2f8c9c0007826eeb7cae14fb20b/8ae3e/menu-too-wide.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-incorrect"
                }}>{`Incorrect`}</p>{`
          `}<p parentName="figcaption">{`
            Don't let menus extend beyond the boundaries of the browser window
            because of long menu labels or other wide content.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "86.10038610038609%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAIAAABSJhvpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB10lEQVQ4y52Qy27TQBSG/SJI5dLGTuPEiauWSqhilRUs4A1AYkFpFIwKQSR1RbtgV6lP0EVo+woVj8GOorCIkriOk1iJ5+LxHM+g1CxQ4jaCX5+OZqT5dEa/ohXsGTJ6Q803tMIUNV/P6HVVryfXGRStYM1grNdypVq2sKeb+8bGZ3PzsLhxoJt2rvQH3dzXTXu1uKcsLb/4m7vLLx+XG8b6ey3f0Ax7q3y09ujLVvkoW7RXcvWllQ937u9qhv0g++me+lHJ6NY8ar62WrRfvT6pvDvbrjZ33n6tWGc71umbanO72qxYp9bu+ZNnx0rp4cEMa5uHuZL99PkxpUxKIYSczjiSAuR1AGIp5cW378rlz+48Py67rV89jEm323Nd7+rK7fUc1+0LMTU5ByHkcDRWANg8cczCkABAHMfJFEIAAOc8+YmUkrFQCQKUymQSYEwcx+n3Pdd12+329bnPGEtkQoiCb0gQBJTSRGu1WoPBwHEcz/M6nU4YhgvkyWQCAEKIMAwxxpxzxhjnnFIKMG2OUnrb5iiKPM8bjUYyLQtkACCEIITiOP5nmTHm+z5C6H82R1E0HA5930+VFxSWFE4ICdIyHo9vlDHGCKHkHUoLxvg2eWF+A+6WInlU0Ju3AAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/f0ffc2d3584b2e3104fd45605e0b817f/8ae3e/menu-item-wrapped.png",
                  "srcSet": ["/version/4.9.1/static/f0ffc2d3584b2e3104fd45605e0b817f/a2ead/menu-item-wrapped.png 259w", "/version/4.9.1/static/f0ffc2d3584b2e3104fd45605e0b817f/6b9fd/menu-item-wrapped.png 518w", "/version/4.9.1/static/f0ffc2d3584b2e3104fd45605e0b817f/8ae3e/menu-item-wrapped.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-correct"
                }}>{`Correct`}</p>{`
          `}<p parentName="figcaption">{`
            Set the width of the dropdown to an appropriate value for where it's
            placed in the UI.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "86.10038610038609%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAIAAABSJhvpAAAACXBIWXMAAAsTAAALEwEAmpwYAAABrElEQVQ4y6WP3S4DQRiG5yY44EAiqru129120VRw4sA9cAWKKRWk3f6kSHCAY9pE4ucS3Iuf9qDJ2C6VxtquandmVrobi0XSxJPnYL7MvO+XAayQ9ejn00wwzQodmaDs52WGl53RI+DDax6laFIcS3LhHC/lxEheim6HIlu8lOXC2YCYYYV0QMwERDvc0zf3af9cb//82OS6bwQODG0wQmZ69mh0cnd69jAQyvk4eZhLsYI8OrEjjOdZQQbLKwW4WoCJIlwtLsVPbI9h4nQxfhGLn8fg+QI8i8HOASYup2b2BplNVsz4g50iYNlQalqUWH9DSOd2/+DKx6Wk6FYokg9F8uDxsVatqopSVdUHSi2MCSHU1j1bhFCMCaX0Xnm6vkG3d/eOAGNMbQgh2KbdbmOMTdMkhJim2Wq1MMbO/re3JsYtV1C1qVQqCKFarVav1xFCpVKpXC5rmoYQUhQFIeTkdb3x8qLresMROGt//tD5pDs6bxo2xgfAbXUrPF1f273hXzf/hTesqqrVNd5ws9k0u0bXdeMLQNO0567xhg3DeO0a4zvA+Af/Cr8DkrszyKvc99IAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/ce0be3fcabff1ac2c7381eedc0ea734d/8ae3e/menu-adjust-placement.png",
                  "srcSet": ["/version/4.9.1/static/ce0be3fcabff1ac2c7381eedc0ea734d/a2ead/menu-adjust-placement.png 259w", "/version/4.9.1/static/ce0be3fcabff1ac2c7381eedc0ea734d/6b9fd/menu-adjust-placement.png 518w", "/version/4.9.1/static/ce0be3fcabff1ac2c7381eedc0ea734d/8ae3e/menu-adjust-placement.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-correct"
                }}>{`Correct`}</p>{`
          `}<p parentName="figcaption">{`
            You can change how the menu aligns with the button to ensure it
            doesn't spill outside the browser viewport.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <h3>{`Height`}</h3>
      <p>{`Dropdowns have a default max-height of 250px and will scroll if necessary. This helps prevent extremely long lists of choices from stretching beyond the top and bottom boundaries of the browser window. 250px is enough to show an average of 6 single line menu choices at once. The max-height can be easily changed if a different value would improve the experience.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "106.1776061776062%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAIAAADJt1n/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB90lEQVQ4y5WUO4vUUBzF97PYa21jqyCiIGJrJ3ZbrIus4nexERubRZzRARFEXRuxUysxuZNsQu4rN/ed+5DJdYbZMePojxAOSU7O/0Gyp3Yh5dZbe6snrNXeG2t13/8+nDMhWOfM38xCyBDs5y+n9/bfPXj86fDRycHRx/sPT/YP39+5+/bJ02/eGzlWwMLMhYyxfzH5ceHi8+u3X129Obly4+W1W9NLl4/PnX92cPTBO825kAOb5lTzaUWns2w6y4dzNnn9c/YGTGbZ1+8oBGcGhjLFZs/DK2QIxnvpeu69iNFqzbxXfW8IIVJK770xhlKqtR4xCyERwk0DIUSMdU0DEcJdxzHGUsoYo1KKEDJuttYmIaU0xnDOlVLGLKaltQ4hjJuToeu6uq6rqqrrum3bqqqapkmCUmqt1VpjjMeTnXP9Eu+9tdYNpCshBO99KmczWSnFGCvLsiiKsiwxxvP5vKoqQkhZloQQpVSMcXzaQgjnnF8SQnDOhbPEGNdXfSa5bVsAQJZlAAAIYZZlRVEghPI8hxDuSI5rpJw/2ZpMKQUA5HkOAEAIpWSMcUpOq96avOo2kbT3PhWyu+f1aQMA0rSLooAQpr62JnPO6UDbtoyxtm0ppV3XUUoZY0IsPqyRPa/8cslKrwQfGPmTJPQ/sNX8v/wCEpOevC5GVoEAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/99b6d58215acbb89dfc777908b4380db/8ae3e/menu-max-height.png",
                  "srcSet": ["/version/4.9.1/static/99b6d58215acbb89dfc777908b4380db/a2ead/menu-max-height.png 259w", "/version/4.9.1/static/99b6d58215acbb89dfc777908b4380db/6b9fd/menu-max-height.png 518w", "/version/4.9.1/static/99b6d58215acbb89dfc777908b4380db/8ae3e/menu-max-height.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-correct"
                }}>{`Correct`}</p>{`
          `}<p parentName="figcaption">{`
            If the dropdown isn't tall enough to show all content, it will
            automatically scroll.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "106.1776061776062%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAIAAADJt1n/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB8klEQVQ4y42TvY7UMBSF52FooaWkBISQQEi0lGi7kUBbrMSDUFBTUFEwszuIlVgJeIGBmiTOBMexk0lsxz/XNtqYGa1gNuHTVWQ7OTnx9cmsn0LKa2/N9k8YrZzTxihrY2kA7b0B0GNiIaR3ev2jPJpfHL/69vLksl6cfJ0ff3n2/Pz1mzWAPuj/RxyCPf+c3Lr97uHT0/uPF3cffXjwZHnn3vsbN98ezS+s7bkQQl7ytzh+c1luTz8my1WyXKXLVbI4+7n6lC3OkvV34j1ordXAVf1sPxJChGCdE2CFAxGC0bpzTgLopmmEEAAQQhBCHBbLvicVrYZq266qKKWs6zhjTAjhnBsTG2N2zZdKKc553/dxUSk15jy0Q/4awBg3TYMxJoS0bYsxrutaax1CiG884AwAdodzzhgDA/uVw87RlnOe76CUbjaboijqui6KglKqlBpzdlfw3gOA934/9d5POKc7CCFpmiKEGGNZlpVl2ff9mHP4D6517rouTdNsoKqqJEkQQpRShFBZllLKMWe/I5rEQWzy9J67rsuyDCEUndM0zfOcMYYQwhhzzif2HE8VAGKTY8PjdLrbRVHEkNV1nec5xni73cbTNsZMJEwpFZNsrTXGaK3jNQZ7ItvV8CsRQmK2GWNt2zLGmqb5N9u/ATjinufu952EAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/772608a097a5a71037eae7db7690b723/8ae3e/menu-too-long.png",
                  "srcSet": ["/version/4.9.1/static/772608a097a5a71037eae7db7690b723/a2ead/menu-too-long.png 259w", "/version/4.9.1/static/772608a097a5a71037eae7db7690b723/6b9fd/menu-too-long.png 518w", "/version/4.9.1/static/772608a097a5a71037eae7db7690b723/8ae3e/menu-too-long.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-caution"
                }}>{`Caution`}</p>{`
          `}<p parentName="figcaption">{`
            Allowing a dropdown to get really tall could make it difficult to
            use.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
      <hr></hr>
      <h2>{`Button Types`}</h2>
      <h3>{`Standard Dropdown Button`}</h3>
      <p>{`The standard dropdown button is the most common element used to trigger a dropdown container.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "93.43629343629343%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAABw0lEQVQ4y6WUzWvUQBjG+/d4FryKVw8eBD8QRL0pVAoqevIfEaGevay6gqULgi14l3rcr+w2y2YmyWwm77yTzDszYsZui5tG0YeX8BDyy5MnycwW/oe21k4hAqjNUUr9AVYKTV15T5tDVHfBDakn06z3Yfj+4/BdmP6w/2nU6w+/HS1NrVvjf8IAynvzavfo0uXerXuD63f2r93cu3F3cOVq/8LFty9efnW2an34NVzvDcYPHn7eeX64/eRg++nB42eHj3a+3L6///rNd0tVKB+02VlpjdaSc9Y5671rDHnvvLfWWiIyxhBRO4yoOedRFE0mk+l0mqbpaDQ6Po455+PxWAhR17X3/mz4KayU8k2icy6Y9fGsaYcRMcuyxWIxn8/jOBZCRFGUJEme57PZLM/zcPdzk621dSMics6FkkRk7a/aXclCCMZYkiSMMSllHMdZlq1Wq+VyWRQFInbBxpiikZRSaw0AZVlqrYuiqKrKWtsFA0BxovAKpJRKKSEEAFRV1dW5LEvOOWMsTVMA4JwLIaSUnHMAOPdTIWIIOV1kJz4YpVRoIaVsW5JN8lrh0t/OQPOXtsCIqP9C7ZvBP+wkPwC8ZyybdaI6dwAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/e010ccaa4b3daa93591e0a13db42d106/8ae3e/simple-dropdown-button.png",
                  "srcSet": ["/version/4.9.1/static/e010ccaa4b3daa93591e0a13db42d106/a2ead/simple-dropdown-button.png 259w", "/version/4.9.1/static/e010ccaa4b3daa93591e0a13db42d106/6b9fd/simple-dropdown-button.png 518w", "/version/4.9.1/static/e010ccaa4b3daa93591e0a13db42d106/8ae3e/simple-dropdown-button.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption">{`Example of single dropdown button.`}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <h3>{`Split Dropdown Button`}</h3>
      <p>{`Split buttons combine a single action button with a menu of related choices into a single component.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "93.43629343629343%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzklEQVQ4y72TT2sTQRjG+3U8CF489CCFCu2haA9+BG/9Ar3ZYyjYhDZBzWeoFCpNFU+erdo14E3ibHY225n9k+zszr/szozsrpElbFQo+OM5vDPMw/O+M8wavwVr9QWlLE2bRSnjjBdaZVYqM0YZo0upmrQxuTGZMZmUgi2ZGeN5Lt++/9E+sXr9Ya8/7L4aVkWhl8PD/tf91seD488OjrO5YKxmppQZM3+692F98/zhzsX65vnW48HOk3fbu5fbu5dbjwZ3Nl7fvX9678HZ1Tdk9LyYYin5zeB76+hLp2c9P74+Orlud612t6g7Xav1wnp2eHXQ+QS8Wb6UXPqpUvNytkpqMaf+vaNUzhhtuDBKKRcC+4Ftjx0HuhMPYx8AOwjCmxsEoUtikmV5mqZCiAazEEJrbRbU64osy1aapZQIIQCAbduu6yKERqOR7/ue543H4yiKGGNFg41tSykbA/81GWPsOA6E0PM8jDEAIIoihBCEcDab/SlZCFFcaIlSSmutFuiSvySHYYgxRggFQRCG4WQyIYRUm0mS/HqUVcmc8+l0SkoopXEc05I4joUQUsrmZM45ISRJkup0WlIvkiQhhDDGmn/Vrf7zfzX/BLwRHeR7/ZHHAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/f990717195cbea07a0312e460704cc69/8ae3e/split-dropdown-button.png",
                  "srcSet": ["/version/4.9.1/static/f990717195cbea07a0312e460704cc69/a2ead/split-dropdown-button.png 259w", "/version/4.9.1/static/f990717195cbea07a0312e460704cc69/6b9fd/split-dropdown-button.png 518w", "/version/4.9.1/static/f990717195cbea07a0312e460704cc69/8ae3e/split-dropdown-button.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption">{`Example of split-dropdown button.`}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <h3>{`Custom Button`}</h3>
      <p>{`Other button variants may be used as a trigger for a dropdown menu. Caution should be used because depending on the label or icon within the button, or where it's used, showing a dropdown menu could be confusing.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "93.43629343629343%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAABVUlEQVQ4y62UTU7DMBCFezS23AQ2iJOw4SrsWbAGIThA1TZJk8Z28M+Mf8ZJkGK1aiAthfKtZpGnN2O9l5k9g9m/ieEEpsUAQERxy25OAxF5751ziPhVjFuEEIwxzrnWmjHWNI0xRgghpSSivu+NMRNiAAghSCk/BgBAa62UQkSlFAC0bdv3/f7mI7H3Ph1mjHHOaa0BIK2ajjronL6oqqosy6qqpJR1XW82GyllOsRae2zttm1pS4wxhLB7MyI6tjYiGmOKosgHOOfrASFEWZZ1XSPiD87dQBpijN2YY85a6yzLlsvlYrFgjGVZtlqtOOd5nhfFGiA5w0RItNYpCd778A2i0HWxbYO1sIvJKGFKKX0ARHN3/3x185jlDZFP+lG23RTWOu8doL2+fbq4fHh7r/o+AOCprUK0RH4+5y+v6xAc/raSiDZG33X09z7vNersn8EnH75CJBKgI/IAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/c4382b46596f4b641fd94268eb78e839/8ae3e/custom-dropdown-button-1.png",
                  "srcSet": ["/version/4.9.1/static/c4382b46596f4b641fd94268eb78e839/a2ead/custom-dropdown-button-1.png 259w", "/version/4.9.1/static/c4382b46596f4b641fd94268eb78e839/6b9fd/custom-dropdown-button-1.png 518w", "/version/4.9.1/static/c4382b46596f4b641fd94268eb78e839/8ae3e/custom-dropdown-button-1.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption">{`
            Example of an icon button used for a series of options related to
            creating or adding something.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "93.43629343629343%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAABWElEQVQ4y6WUO07EMBCG91C03ICWI9BxAipuRAeiA4kCIW4AEqtkNy8ncfyYsRPHDiIjrUAk2WX5i18z8nyZ+Lky/9Dq8FIABMBjYGtNCG4Y+ra1+FcYER+f4tv7j5qrLx4PgxHRdTbLxdn53cnpzctrMgyO/n/1vYh8J0oB0FrDubq6fr64fHh7L71vafQH3LZt3/fee3LnnB9F6TD4ELwxOL1gABDHcRRF6/U6TdPNZhPHcVVVURRlWWaM9d4DwAQMAOPnB3JSCIGcglmY+CRJqCdjLB3VNM12u2WMKaWWOjvn+r7vuo5mu5s/Bd77EMJS56IoyrLM85xzTrGUsiiKpmm01ns6A4AQQmtNRVprckSk/tMwbZWUUmtNvBhljKHUGLMEW2urqmKMlWUphOCc13WtlKrrWkpp7fxW6VGTx3N38pRSSwum5wWjZq+kPUBHPga/X5JPKqVAkhBTwvMAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/663144e653a0b99cc0ba9c9b39abae79/8ae3e/custom-dropdown-button-2.png",
                  "srcSet": ["/version/4.9.1/static/663144e653a0b99cc0ba9c9b39abae79/a2ead/custom-dropdown-button-2.png 259w", "/version/4.9.1/static/663144e653a0b99cc0ba9c9b39abae79/6b9fd/custom-dropdown-button-2.png 518w", "/version/4.9.1/static/663144e653a0b99cc0ba9c9b39abae79/8ae3e/custom-dropdown-button-2.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption">{`Example of a "more options" dropdown menu.`}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
      <hr></hr>
      <h2>{`Positioning & Alignment`}</h2>
      <p>{`Dropdowns are positioned relative to the trigger element that is clicked on to open it.`}</p>
      <p>{`A dropdown is typically displayed below the trigger element, and the left edge of the dropdown is aligned with the left edge of the trigger element. To make sure dropdowns don’t become obscured by running off the edge of the browser, you may position the dropdown to the left, right, or above the trigger element. You may also change the alignment to the right, top, or bottom edges.`}</p>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.87644787644788%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAABJElEQVQoz3VRu04DMRC8r0RKE5ECiYIqFR9BxW9EOgQUiEcEBSBKaogEAro4Xtt7u177kjt0Z3EkB5nK2tnZGXky731Vxbou67qsqui3Y7kMaa2ulyLNJGPmi8u3/HQ2yV+upu/M/FfG7EOQh6evSf6an81OzmcaMATJioIPxvej/bud4fX48JHIiwgRrymb92oVj46fB7vT4d7tYHTz8QllGRpnRJrPQSkDYBGRiEIIScPMIoKIzjkAoxZWLQyzpLtZS3tES1QkMHOMcV3sWrQUMVOM8VfMzEqpRQsAsNb2nAEgLQCA1lpkzdl7b20TGBGLotgWO7GIGELYcNZa2x8453piY0xK5Jwzxmw4E1F3uzPvOuux6UcTm3VldMUk9Cb/st/rsi/MYeZ2/QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/version/4.9.1/static/6318a88e65d682079301ab0901d130d9/e3189/dropdown-alignment-1.png",
            "srcSet": ["/version/4.9.1/static/6318a88e65d682079301ab0901d130d9/a2ead/dropdown-alignment-1.png 259w", "/version/4.9.1/static/6318a88e65d682079301ab0901d130d9/6b9fd/dropdown-alignment-1.png 518w", "/version/4.9.1/static/6318a88e65d682079301ab0901d130d9/e3189/dropdown-alignment-1.png 1035w", "/version/4.9.1/static/6318a88e65d682079301ab0901d130d9/307e7/dropdown-alignment-1.png 1354w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Dropdowns can be left or right aligned.`}</p>{`
  `}</figcaption>
      </figure>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.87644787644788%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAABGklEQVQoz6WRPUsEMRCG96daiBx4IIiV2PkPPHBFxcJCLGwFK/UQC8vjBLGx00p3k5nM5Gv3VnZnjetp50vIhJk8eYdMZv+hjJnl5JxLB+dcyi+VZJdqRkTWWq01IgIAIjJzjFHy1lpmhk6IaDrFGHtYQlEUuhMAGGNCCMmZmcuylKoYpOoPZ3mbiJZgsUVEIkLEIdwGpVRq+zeslJKmiIwxA1iC1qUxQNQ7eO8TTEQCIwK3MFQx9L8NQFvb9+PNu5XR9c7uAxEzszFmCBNx8HZvf7a6fjvamK6Nb17fVIyubfv07Ck/nk/y2fnF82BA32K2wbvLq5fJwSw/mh+ePL5/oPcus9YuFlXTyIpfE/1DdR27O3XTVHLtEyZYMHIYb0nvAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/version/4.9.1/static/47e7e613b7d6795c5ea328010ae4e852/e3189/dropdown-alignment-2.png",
            "srcSet": ["/version/4.9.1/static/47e7e613b7d6795c5ea328010ae4e852/a2ead/dropdown-alignment-2.png 259w", "/version/4.9.1/static/47e7e613b7d6795c5ea328010ae4e852/6b9fd/dropdown-alignment-2.png 518w", "/version/4.9.1/static/47e7e613b7d6795c5ea328010ae4e852/e3189/dropdown-alignment-2.png 1035w", "/version/4.9.1/static/47e7e613b7d6795c5ea328010ae4e852/307e7/dropdown-alignment-2.png 1354w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`
      Dropdowns can be positioned above the trigger element. If using a button,
      you should use the dropup button style.
    `}</p>{`
  `}</figcaption>
      </figure>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.87644787644788%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA9klEQVQoz52SPU4DMRCFffM06Sm4BAUSBZeAICQQFRItSCjC9s6f7fFmjdZDNlFClVeN3/izx3p2IkkkXSanmlvT84bsj8w5/+vP8NPz12q9AZBSDltzzqrKzMvy2F949/r2fXX9EiN6/xNC8N7HGAGg1ppSIqLtdhu6Fv8Aq5bWtJQMgMxMRMycUrIbcs4AwF3G1FqJhXvtRIRoboQQoAsRiUhV7YXee0Q89qdJa1WR5GyHwcMw2GyIaDAze++HLoAZ3u3q3f3Hw+ZzmvQPZuYYI+5FREae++NYVuvHm9v31kZ3EoAVNstJMGb2CJLF5y74G0vwv4mOOt3xY/TbAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/version/4.9.1/static/e28a1a5f34ba6212beac9b12adb6c9c3/e3189/dropdown-alignment-3.png",
            "srcSet": ["/version/4.9.1/static/e28a1a5f34ba6212beac9b12adb6c9c3/a2ead/dropdown-alignment-3.png 259w", "/version/4.9.1/static/e28a1a5f34ba6212beac9b12adb6c9c3/6b9fd/dropdown-alignment-3.png 518w", "/version/4.9.1/static/e28a1a5f34ba6212beac9b12adb6c9c3/e3189/dropdown-alignment-3.png 1035w", "/version/4.9.1/static/e28a1a5f34ba6212beac9b12adb6c9c3/307e7/dropdown-alignment-3.png 1354w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`
      Dropdowns can be positioned to the left or right of the trigger element.
    `}</p>{`
  `}</figcaption>
      </figure>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      